import React from 'react';
import SarasWrapper from '../../container/SarasWrapper';
import SarasTooltip from '../../notifications/SarasTooltip';
import SarasTrans from '../../notifications/SarasTrans';
import * as fn from '../../../helper/uiFunctions';

const FormROValueWithTrans = (props) => {
    const { formObject, translate, action, useVal, 
        hideIfEmpty, maxValueLength, rowKey, headerKey, format, 
        customWrapper, wrapperClass, className, yesClass, noClass, tooltip, ...restProps } = props;

    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");

    const getValue = () => {
        let value = "";
        
        if(useVal){
            value= formObject.getValueFromKey(viewData, "dataList.valS", viewData.val);
        }
        else{
            value = formObject.getValueFromKey(viewData, "dataList.valS", viewData.valF || viewData.val);
        }

        let title = '';

        if (format === "#" && fn.compareNumber(value, 0))
            value = '';

        if (format === "a" && fn.compareNumber(value, 0))
            value = '-';

        if (format === "hhmm")
            value = fn.convertMinutesToHHMM(viewData.val);

        if(translate){
            return {value: <SarasTrans value={value} />, title: ""};
        }

        if(maxValueLength && value.length > maxValueLength){
            title = value;
            value = value.substring(0, maxValueLength) + " ...";
        }

        return {val: viewData.val, valF: value, title: title};
    }

    const getStyle = () => {
        if (viewData.dataList && viewData.dataList.colCssStyle && viewData.dataList.colCssStyle !== "") {
            return JSON.parse(viewData.dataList.colCssStyle)
        }
        else {
            return {}
        }
    }

    // if(action.paramName =="pnrError") console.log("pnrError : ", viewData)

    if (viewData && hide === "0") {
        let displayValue = getValue();

        if(hideIfEmpty && displayValue.valF === ""){
            return null;
        }

        //if any of the boolean classes are provided then set the class according to the val
        let boolClass = "";

        if(yesClass || noClass){
            boolClass = fn.compareNumber(displayValue.val, 1) ? yesClass : noClass;
        }

        return (
            <SarasWrapper customWrapper={customWrapper} wrapperClass={wrapperClass}>
                <SarasTooltip title={displayValue.title || tooltip || ''}>
                    <span className={`${className} ${boolClass} ${viewData.dataList ? viewData.dataList.colCssClass : ''}`} style={getStyle()} {...restProps}><SarasTrans value={displayValue.valF} /></span>
                </SarasTooltip>
            </SarasWrapper>
        )
    }

    return (null);
}

export default FormROValueWithTrans